import { render, staticRenderFns } from "./Reciptiant.vue?vue&type=template&id=c31cb054"
import script from "./Reciptiant.vue?vue&type=script&lang=js"
export * from "./Reciptiant.vue?vue&type=script&lang=js"
import style0 from "./Reciptiant.vue?vue&type=style&index=0&id=c31cb054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports